import { IDependenciesRecord } from '../../../ModuleStore/interfaces/IDependencies';
import { DEFAULT_ACTIVE_MODULE } from './COMMON_BOARD_ACTIVE_MODULES';

export const COMMON_WELCOME_REQUIRED_MODULES: IDependenciesRecord = {
    LanguageSelect: DEFAULT_ACTIVE_MODULE,
};
